export enum NotesTabContext {
  Submissions = 1,
  Records = 2
}